import React from "react";
import { Modal, Box } from "@mui/material";
import { styled } from "@mui/system";

import Button from "../Button";

import "./styles.css";

const ModalBox = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "500px",
  backgroundColor: "white",
  borderRadius: "8px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  padding: "24px",
  outline: "none",
});

export default function ConfirmModal({
  open,
  onClose,
  title,
  text,
  cancelButtonLabel = "Cancelar",
  confirmButtonLabel = "Confirmar",
  cancelButtonColor = "#d32f2f",
  confirmButtonColor = "#2e7d32",
  onCancel,
  onConfirm,
  notShowCancel = false,
}) {
  const handleClose = onClose || (() => {});

  return (
    <Modal 
      open={open} 
      onClose={handleClose}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <ModalBox className="confirm-modal-body">
        {title && (
          <h2 className="confirm-modal-title">
            {title}
          </h2>
        )}
        {text && (
          <p className="confirm-modal-text">
            {text}
          </p>
        )}
        <div className="confirm-modal-buttons">
          {!notShowCancel ? (
            <Button
              onClick={onCancel || handleClose}
              style={{
                backgroundColor: cancelButtonColor,
                color: "white",
              }}
            >
              {cancelButtonLabel}
            </Button>
          ) : (
            <div />
          )}
          <Button
            onClick={onConfirm}
            style={{
              backgroundColor: confirmButtonColor,
              color: "white",
            }}
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </ModalBox>
    </Modal>
  );
}

